import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useBeneficiosNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    history.push(`/pages/beneficios/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    history.push('/pages/beneficios/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    history.push(`/pages/beneficios/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
